import { useMemo as m } from "react";
import { useMediaQueries as a } from "./atoms-v258.js";
import { tokens as i } from "./atoms-v257.js";
const h = () => {
  const o = m(() => {
    const e = Object.entries(i.breakpoints);
    return e.reduce((c, [p, n], r) => {
      let s = "";
      if (r === 0 || r === Object.keys(i.breakpoints).length - 1)
        s = n.toExpression();
      else {
        const u = e[r + 1];
        s = `${n.toExpression()} and (width < ${u[1].size}px)`;
      }
      return { ...c, [p]: s };
    }, {});
  }, []), { matches: t } = a(o);
  return { current: Object.keys(t).find(
    (e) => t[e]
  ), matches: t, queries: o };
};
export {
  h as useBreakpoints
};
